"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ToolbarLayout: true
};
exports.default = exports.ToolbarLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ToolbarLayout = require("./_ToolbarLayout.types");
Object.keys(_ToolbarLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToolbarLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToolbarLayout[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const ToolbarLayout = exports.ToolbarLayout = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(ToolbarLayout, _props)) : _props;
  const {
      children,
      hide,
      replaceWith,
      overflowOrder: _overflowOrder,
      sm: _sm,
      md: _md,
      lg: _lg,
      xl: _xl
    } = props,
    otherProps = __rest(props, ["children", "hide", "replaceWith", "overflowOrder", "sm", "md", "lg", "xl"]);
  return !hide && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    ref: ref
  }), replaceWith || children));
});
ToolbarLayout.displayName = 'ToolbarLayout';
var _default = exports.default = ToolbarLayout;